import React from "react";
import DetailHeader from "../DetailsHeader/DetailHeader";
import Styles from "./Transactions.module.css";
import { useSelector } from "react-redux";

const Transactions = () => {
  const data = useSelector((state) => state?.paymentSlice);
  let transaction = data?.walletTransaction;
  const handleSelect = () => {};
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <DetailHeader
        heading={"Transactions"}
        handleSelect={handleSelect}
        list={
          [
            // { name: "All", value: "all", status: true },
            // { name: "Ongoing", value: "ongoing", status: false },
            // { name: "Completed", value: "completed", status: false },
            // { name: "Pending", value: "pending", status: false },
          ]
        }
      />
      <div className={Styles.tableMainElem}>
        <div
          className={`display_flex_row tableHeading ${Styles.headingMainTable}`}
        >
          <div style={{ width: "15%" }}>Self Listing</div>
          <div style={{ width: "15%" }}>Counterparty Name</div>
          <div style={{ width: "15%" }}>Contract Id</div>
          <div style={{ width: "15%" }}>Transaction Date</div>
          <div style={{ width: "15%" }}>Transaction Amount (₹)</div>
          <div style={{ width: "10%" }}>Type</div>
          <div style={{ width: "10%" }}>Action</div>
        </div>
        <div className={`scroll_bar_y ${Styles.viewMainElem}`}>
          {transaction?.map((ele, index) => (
            <div className="display_flex_row tableDetails">
              <div style={{ width: "15%" }}>
                {ele?.listingId?.split("_")?.[0] || "-"}
              </div>
              <div style={{ width: "15%" }}>
                <div>
                  {(ele?.counterPartyName === "UNKNOWN"
                    ? ""
                    : ele?.counterPartyName) || "-"}
                </div>
                {ele?.counterPartyListingId && (
                  <div style={{ fontSize: "8px" }}>
                    {ele?.counterPartyListingId || "-"}
                  </div>
                )}
              </div>
              <div style={{ width: "15%" }}>
                {ele?.bilateralContractUniqueId || "Not Generated"}
              </div>
              <div style={{ width: "15%" }}>{ele?.dateTime}</div>
              <div style={{ width: "15%" }}>{ele?.amount?.toFixed(2)}</div>
              <div style={{ width: "10%" }}>
                {ele?.paymentType?.split("_")?.join(" ") || "-"}
              </div>
              <div
                style={{
                  width: "10%",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
                className={
                  ele?.activity === "CREDIT" || ele?.activity === "RELEASED"
                    ? "accepted"
                    : "rejected"
                }
              >
                {ele?.activity}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Transactions;
